import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTrash } from 'react-icons/hi2';

const WorkPermitStep6Isolations = ({ formData, handleArrayChange }) => {
  const isolations = JSON.parse(formData.isolationsJson || '[]');
  const [newIso, setNewIso] = useState({ isolationPoint: '', isolationType: '', isolationMethod: '', lockNumber: '', tagNumber: '' });

  const addIsolation = () => {
    if (!newIso.isolationPoint) return;
    handleArrayChange('isolationsJson', [...isolations, { ...newIso }]);
    setNewIso({ isolationPoint: '', isolationType: '', isolationMethod: '', lockNumber: '', tagNumber: '' });
  };

  const removeIso = (idx) => {
    const copy = [...isolations];
    copy.splice(idx, 1);
    handleArrayChange('isolationsJson', copy);
  };

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">6. Isolations (LOTO)</h3>
      <div className="array-field-container">
        {isolations.length === 0 && <p>No isolations added.</p>}
        {isolations.map((iso, idx) => (
          <div key={idx} className="form-row">
            <div className="form-group ">
            <input
              type="text"
              value={iso.isolationPoint}
              onChange={(e) => {
                const copy = [...isolations];
                copy[idx].isolationPoint = e.target.value;
                handleArrayChange('isolationsJson', copy);
              }}
              placeholder="Point"
            />
            </div>
            <div className="form-group ">
            <input
              type="text"
              value={iso.isolationType}
              onChange={(e) => {
                const copy = [...isolations];
                copy[idx].isolationType = e.target.value;
                handleArrayChange('isolationsJson', copy);
              }}
              placeholder="Type"
            />
            </div>
            <div className="form-group ">
            <input
              type="text"
              value={iso.isolationMethod}
              onChange={(e) => {
                const copy = [...isolations];
                copy[idx].isolationMethod = e.target.value;
                handleArrayChange('isolationsJson', copy);
              }}
              placeholder="Method"
            />
            </div>
            <div className='form-group'>
            <input
              type="text"
              value={iso.lockNumber}
              onChange={(e) => {
                const copy = [...isolations];
                copy[idx].lockNumber = e.target.value;
                handleArrayChange('isolationsJson', copy);
              }}
              placeholder="Lock #"
            />
            </div>
            <div className='form-group'>
            <input
              type="text"
              value={iso.tagNumber}
              onChange={(e) => {
                const copy = [...isolations];
                copy[idx].tagNumber = e.target.value;
                handleArrayChange('isolationsJson', copy);
              }}
              placeholder="Tag #"
            />
            </div>
            <button type="button" className="btn-icon-delete wd50size" onClick={() => removeIso(idx)}>
              <HiOutlineTrash />
            </button>
          </div>
        ))}
        <div className="form-row">
          <div className='form-group'>
          <input
            type="text"
            value={newIso.isolationPoint}
            onChange={(e) => setNewIso((prev) => ({ ...prev, isolationPoint: e.target.value }))}
            placeholder="Point"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newIso.isolationType}
            onChange={(e) => setNewIso((prev) => ({ ...prev, isolationType: e.target.value }))}
            placeholder="Type"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newIso.isolationMethod}
            onChange={(e) => setNewIso((prev) => ({ ...prev, isolationMethod: e.target.value }))}
            placeholder="Method"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newIso.lockNumber}
            onChange={(e) => setNewIso((prev) => ({ ...prev, lockNumber: e.target.value }))}
            placeholder="Lock #"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newIso.tagNumber}
            onChange={(e) => setNewIso((prev) => ({ ...prev, tagNumber: e.target.value }))}
            placeholder="Tag #"
          />
          </div>
          <button type="button" className="btn-primary wd50size" onClick={addIsolation}>
            <HiOutlinePlus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep6Isolations;

